import { Spacer } from 'app/layouts/generic';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { IconInput } from 'app/shared/input';
import GmModal from 'app/shared/modal/modal';
import { useSubscriptionService } from 'hooks/sales/subscription';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { NeuronForm } from './form';
import { NeuronListPage } from './list';
import styles from './neurons.module.css';
import { Icon } from 'assets/icons';
import { TableFilter } from 'app/shared/filter';
import { useEventsService } from 'hooks/automation/event';
import { filter_config } from './config/filter';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';

export const NeuronModule = () => {
  const dispatch = useDispatch();

  const { fetchEvents } = useEventsService();
  const { fetchSubscription } = useSubscriptionService();

  const [events, setEvents] = useState([]);
  const [filter_query, setFilterQuery] = useState('');
  const [has_subscription, setHasSubscription] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [show_creation_form, setShowCreationForm] = useState(false);
  const [show_filter, setShowFilter] = useState(false);

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Autoresponder', path: '/neurons' }]));
    fetchSubscription({
      query_string: 'plan_code=campaign&status=active'
    }).then(({ subscriptions: [subscription] }) => {
      if (!subscription) return;

      setHasSubscription(() => subscription && subscription.tier === 'enterprise');
    });
    fetchEvents().then(({ events }) => {
      setEvents(events.map((e) => ({ value: e.code, label: e.name })));
    });
  }, []);

  return (
    <PageContentWrapper>
      <GridRow num_of_columns={5}>
        <GridColumn>
          <div className={styles.searchWrapper}>
            <IconInput
              wrapperClassName={styles.searchInputGroup}
              placeholder="Search autoresponders"
              value={keyword}
              icon_name="search"
              onInput={setKeyword}
              is_rounded
            />
            <Icon name="filter" onClick={() => setShowFilter(true)} />
          </div>
        </GridColumn>
        <GridColumn span={3} />
        <GridColumn>
          <Button
            text="Autoresponder"
            icon_name="add"
            disabled={!has_subscription}
            onClick={() => setShowCreationForm(true)}
          />
        </GridColumn>
      </GridRow>
      <Spacer multiple={4} />
      <GridRow num_of_columns={1}>
        <GridColumn>
          <NeuronListPage keyword={keyword} filter={filter_query} />
        </GridColumn>
      </GridRow>
      <GmModal
        bodyClassName={styles.formWrapper}
        position="right"
        show_title
        show_modal={show_creation_form}
        title="Create Autoresponder"
        onClose={() => setShowCreationForm(false)}
      >
        <NeuronForm />
      </GmModal>
      <TableFilter
        config={filter_config(events)}
        is_open={show_filter}
        onApply={setFilterQuery}
        onClose={() => setShowFilter(false)}
      />
    </PageContentWrapper>
  );
};
